import { createFileRoute } from '@tanstack/react-router';
import { AdvancedDataView } from '@/components/AdvancedDataView';

export const Route = createFileRoute('/_authenticated/advanced-data')({
  component: AdvancedDataView,
});
